import { defineEvent } from "@otto-ec/global-resources/nexus";
import type { AsyncNamespaceInput, FunctionImplementation } from "@otto-ec/global-resources/nexus";
import { get } from "svelte/store";
import { delegate } from "@otto-ec/global-resources/event";
import { parseParameters } from "@otto-ec/global-resources/attribute-parser";
import * as getters from "./lib/getters";
import type { SheetV1 } from "./index.js";
import type { OcSheetV1Props } from "./SheetV1.types.g";
import { getSheetElement } from "./lib/getters";
import { back, openSheet, next, close } from "./lib/sheetHistory";
import { applyProps } from "./lib/utils";

const TAG_NAME = "oc-sheet-v1";

const API_PREFIX = `data-${TAG_NAME}`;

const TRIGGER_OPEN = "open";

const TRIGGER_CREATE = "create";

const EVENT_CLICK = "click";

const DATA_SHEET_OPEN = `${API_PREFIX}-${TRIGGER_OPEN}`;

const DATA_SHEET_CREATE = `${API_PREFIX}-${TRIGGER_CREATE}`;

/**
 *
 *
 */
const DATA_SHEET_OPEN_LEGACY = "data-oc-sheet-id";

/**
 *
 *
 */
const DATA_SELECTORS = ([DATA_SHEET_OPEN, DATA_SHEET_CREATE, DATA_SHEET_OPEN_LEGACY] as const).map(
  (s) => `[${s}]` as const,
) as ["[data-oc-sheet-v1-open]", "[data-oc-sheet-v1-create]", "[data-oc-sheet-id]"];

/**
 *
 */
export const create = function create(
  config = {},
  clickedElement: HTMLElement | undefined = undefined,
) {
  const sheet = document.createElement(TAG_NAME) as HTMLOcSheetV1Element;

  /*                    */
  applyProps(sheet, config);

  /*                                                                    */
  /*                                                                                      */
  if (import.meta.env.STORYBOOK && clickedElement) {
    clickedElement.insertAdjacentElement("afterend", sheet);
    return sheet;
  }

  document.body.append(sheet as Node);
  return sheet;
} satisfies FunctionImplementation<SheetV1["create"]>;

/*                                                                               */
export const sheetV1: AsyncNamespaceInput<OttoComponentApi["sheetV1"]> = {
  open: next,
  close,
  back,
  create,
  getOpenSheet: () => get(openSheet),
  getContent: () => getters.getContent(get(openSheet)),
  getHeader: () => getters.getHeader(get(openSheet)),
  getActions: () => getters.getActions(get(openSheet)),
  openEvent: defineEvent(),
  closeEvent: defineEvent(),
  switchEvent: defineEvent(),
  contentLoadedEvent: defineEvent(),
  contentLoadingErrorEvent: defineEvent(),
};

/**
 *
 *
 */
function handleOpenOnClick(event: MouseEvent): void {
  const clickedElement = event.target as HTMLElement;
  const disabled = clickedElement.getAttribute("disabled");
  if (disabled) {
    return;
  }

  const sheetID = clickedElement.getAttribute(DATA_SHEET_OPEN_LEGACY);
  if (sheetID) {
    /*                            */
    next(sheetID);
    return;
  }

  const config = parseParameters<OcSheetV1Props>(API_PREFIX, TRIGGER_OPEN, clickedElement);
  if (config.id) {
    next(config.id, config);
  }
}

/**
 *
 *
 */
function handleCreateOnClick(event: MouseEvent): void {
  const clickedElement = event.target as HTMLElement;
  const config = parseParameters<OcSheetV1Props>(API_PREFIX, TRIGGER_CREATE, clickedElement);
  const sheetElement = getSheetElement(config.id);

  if (sheetElement) {
    /*                                            */
    sheetElement.open = true;
    return;
  }

  const sheet = create(config, clickedElement);
  /*                                                                                           */
  clickedElement.setAttribute(`${DATA_SHEET_CREATE}.id`, sheet.id);
}

delegate(window.document, EVENT_CLICK, DATA_SELECTORS[0], handleOpenOnClick);
delegate(window.document, EVENT_CLICK, DATA_SELECTORS[2], handleOpenOnClick);
delegate(window.document, EVENT_CLICK, DATA_SELECTORS[1], handleCreateOnClick);
